import { IconButton, Stack, useTheme } from "@mui/material";
import { CircleUserRound } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DashboardHeaderActions } from "web_myplann/Dashboard/Components/DashboardHeaderActions";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

type DashboardEmptyHeaderProps = {
	title: string;
};

export const DashboardEmptyHeader = ({ title }: DashboardEmptyHeaderProps) => {
	const { palette } = useTheme();
	const navigate = useNavigate();

	return (
		<NavigationHeader
			title={title}
			disableBottomPadding
			startComponent={
				<IconButton
					sx={{ padding: 0 }}
					onClick={() => {
						navigate(Routing.Profile.ProfileDetail.path());
					}}
				>
					<CircleUserRound color={palette.grey[700]} />
				</IconButton>
			}
			endComponent={
				<Stack direction="row" gap={1.6}>
					<DashboardHeaderActions variant="flat" />
				</Stack>
			}
		/>
	);
};
